import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { SxProps, Box } from '@mui/material'

import './LiveEventsNotPublishedBadge.scss'

type LiveEventsNotPublishedBadgeProps = {
  sx?: SxProps
}

export const LiveEventsNotPublishedBadge: FC<LiveEventsNotPublishedBadgeProps> = ({ sx }) => {
  const { t } = useTranslation()
  return (
    <Box className="LiveEventsNotPublishedBadge" sx={sx}>
      <div className="LiveEventsNotPublishedBadge__Badge">{t('live-events:not_published_badge')}</div>
    </Box>
  )
}
